export function transformArticleImagesForStaticHtml(html) {
  if (!html) return "";
  const raw = String(html);

  // Use a narrowly scoped regex to find exactly `<img ...>` tags.
  // It replaces the <img> tag with a wrapper div and a native <img> with loading="lazy".
  return raw.replace(/<img\b([^>]*)>/gi, (match, attrs) => {
    // 1. Parse existing attributes to retain them
    let src = "";
    let alt = "Blog image";
    let width = "1200";
    let height = "800";
    let className = "";
    let style = "";

    // Safely extract attributes without assuming order or quoting
    const srcMatch = attrs.match(/\bsrc\s*=\s*(["'])(.*?)\1/i);
    if (srcMatch) src = srcMatch[2];
    
    // If there is no src, preserve the original tag
    if (!src) return match;

    const altMatch = attrs.match(/\balt\s*=\s*(["'])(.*?)\1/i);
    if (altMatch) alt = altMatch[2];

    const widthMatch = attrs.match(/\bwidth\s*=\s*(["']?)(\d+)\1/i);
    if (widthMatch) width = widthMatch[2];

    const heightMatch = attrs.match(/\bheight\s*=\s*(["']?)(\d+)\1/i);
    if (heightMatch) height = heightMatch[2];
    
    // Check if there are existing classes to preserve (optional, but good for fidelity)
    const classMatch = attrs.match(/\bclass\s*=\s*(["'])(.*?)\1/i);
    if (classMatch) className = classMatch[2];

    const styleMatch = attrs.match(/\bstyle\s*=\s*(["'])(.*?)\1/i);
    if (styleMatch) style = styleMatch[2];

    // 2. Build the final native img tag
    // We append the specific responsive classes and styles expected by the layout.
    const finalClass = `w-full h-auto object-contain block ${className}`.trim();
    const finalStyle = `width:100%;height:auto;object-fit:contain;${style}`;
    
    const nativeImg = `<img src="${src}" alt="${alt}" width="${width}" height="${height}" class="${finalClass}" style="${finalStyle}" sizes="(max-width: 1023px) 100vw, 800px" loading="lazy" />`;
    
    // 3. Wrap in the layout container exactly as it was in React
    return `<div class="relative w-full rounded-2xl overflow-hidden mt-6 mb-2 flex justify-center">${nativeImg}</div>`;
  });
}
